import { Component, effect, inject, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationHubService } from './shared/services/notification/notification-hub.service';
import { UserProfileStore } from './shared/states/user-profile/user-profile.store';
import { AuthenticationStore } from './shared/states/auth/auth.store';
import { SessionExpiryService } from './shared/services/session/session-expiry.service';

@Component({
  selector: 'app-root',
  standalone: false,
  template: `
    <router-outlet />
    <app-global-spinner />

    <p-dialog
      header="Session expired"
      [visible]="sessionExpiry.expired()"
      [modal]="true"
      [closable]="false"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '420px' }"
      styleClass="session-expired-dialog">
      <p style="margin: 0 0 8px; color: var(--tp-text);">
        Your session has ended. Sign in again to continue.
      </p>
      <ng-template pTemplate="footer">
        <button
          pButton
          type="button"
          label="Sign in"
          icon="pi pi-sign-in"
          (click)="onSessionExpiredConfirm()">
        </button>
      </ng-template>
    </p-dialog>
  `,
})
export class App implements OnDestroy {
  readonly userProfileStore = inject(UserProfileStore);
  readonly notificationHubService = inject(NotificationHubService);
  readonly sessionExpiry = inject(SessionExpiryService);
  private readonly authStore = inject(AuthenticationStore);

  isConnected$: Observable<boolean>;

  private hubStarted = false;

  constructor() {
    this.isConnected$ = this.notificationHubService.isConnected$;

    // Wait until the user profile is loaded and employeeGuid is available
    // before starting the hub connection. This prevents subscribing with an
    // empty userId when the store hasn't rehydrated yet.
    effect(() => {
      const employeeGuid = this.userProfileStore.employeeGuid();
      if (employeeGuid && !this.hubStarted) {
        this.hubStarted = true;
        this.notificationHubService.startConnection(employeeGuid);
      }
    });
  }

  onSessionExpiredConfirm(): void {
    this.sessionExpiry.acknowledge();
    this.authStore.logout();
  }

  ngOnDestroy(): void {
    this.notificationHubService.stopConnection();
  }
}
